import type { SVGProps } from 'react'
const SvgSyPaper = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M8.084 2.012C5.62 2.012 3.5 3.999 3.5 6.49v10.713c0 2.557 2.01 4.662 4.584 4.662h7.988c2.51 0 4.48-2.196 4.48-4.662V8.037a.75.75 0 0 0-.208-.517l-5.067-5.278a.75.75 0 0 0-.54-.23zm0 1.5h6.332l4.637 4.828v8.863c0 1.656-1.37 3.162-2.98 3.162h-7.99C6.308 20.365 5 18.998 5 17.203V6.49c0-1.629 1.43-2.978 3.084-2.978"
				clipRule="evenodd"
			/>
			<path d="M14.475 2a.75.75 0 0 0-.75.75v2.91a3.335 3.335 0 0 0 3.316 3.324c.659.002 1.324.002 1.838.002h.639c.161 0 .182.004.328-.006a.75.75 0 0 0 .699-.796.75.75 0 0 0-.797-.7c.1-.006-.08.002-.238.002h-.631c-.512 0-1.178 0-1.836-.002a1.81 1.81 0 0 1-1.818-1.824V2.75a.75.75 0 0 0-.75-.75" />
			<path
				d="M8.887 14.809a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h5.396a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75zm0-4.954a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h3.355a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyPaper
